import { SET_MIGRATION_DIALOG } from "../actions/migrations"
import { SET_FEES_MIGRATION, SET_ITEMS_MIGRATION } from "../yoello-lib/modules/redux/actions/migration.actions"

export interface IMigrationState {
    isMigrateFees: boolean;
    isOpen: boolean;
    isMigrateItems: boolean;
}

const initalState = {
    isMigrateFees: false,
    isMigrateItems: false,
    isOpen: false
}

export function migrationReducer(state: IMigrationState = initalState, action: { type: string, payload: boolean }) {
    switch (action.type) {
        case SET_FEES_MIGRATION:
            return {
                ...state,
                isMigrateFees: action.payload
            }
        case SET_ITEMS_MIGRATION:
            return {
                ...state,
                isMigrateItems: action.payload
            }
        case SET_MIGRATION_DIALOG:
            return {
                ...state,
                isOpen: action.payload
            }
        default:
            return {
                ...state
            }
    }
}